import { Alert } from "PFComponents/alert";
import { Button } from "PFComponents/button";
import Toggle from "PFComponents/toggle/toggle";
import { getProfileName } from "PFCore/helpers/profile";
import { profileHash } from "PFCore/helpers/profile_hash";
import useForceUpdate from "PFCore/helpers/use_force_update";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import ExportableProfiles from "../helpers/exportable_profile";
import css from "./profiles_tab.less";

const ProfilesTab = ({ exportableProfiles, handleClick, isBlindModeOn }) => {
  const { t } = useTranslation();

  const forceUpdate = useForceUpdate();

  const toggleAllProfiles = () => {
    const allEnabled = exportableProfiles.map((profile) => profile.enabled !== false).every(Boolean);
    exportableProfiles.map((profile) => (profile.enabled = !allEnabled));

    forceUpdate();
    handleClick();
  };

  return (
    <>
      {exportableProfiles.countEnabled() === 0 && (
        <Alert
          kind="warning"
          title={t("export.profiles.noProfileSelected")}
          style={{ marginBottom: 20, marginTop: 20 }}
        >
          {t("export.profiles.selectAtLeastOneProfile")}
        </Alert>
      )}
      <div className={css.toggleAll}>
        <Button text={t("export.profiles.toggleAll")} small onClick={toggleAllProfiles} />
      </div>
      <ul style={{ padding: 0 }}>
        {exportableProfiles.map((profile, index) => {
          const candidate = isBlindModeOn
            ? `${t("export.profiles.candidate")} ${profileHash(profile.profile.id)}`
            : getProfileName(profile);
          const jobTitle = profile.mainJobTitle ? ` - ${profile.mainJobTitle}` : "";
          const toggleDescription = `${candidate}${jobTitle}`;
          return (
            <li key={`${profile.profile.id}+${index}`} className={css.listItem}>
              <Toggle
                inline
                reversed
                description={toggleDescription}
                checked={profile.enabled !== false}
                onChange={(checked) => {
                  profile.enabled = checked;
                  handleClick();
                  forceUpdate();
                }}
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};

ProfilesTab.propTypes = {
  exportableProfiles: PropTypes.instanceOf(ExportableProfiles),
  handleClick: PropTypes.func,
  isBlindModeOn: PropTypes.bool
};

export default ProfilesTab;
